import React from 'react'
import type { BetSlipItem } from '@mobi/betslip/types'

export const MultiLegTypeToggle: React.FC<{ item: BetSlipItem }> = ({ item }) => {
  // const prices = item.selection as FobSelection
  // const { multiLegBetType } = item
  // const priceToDisplay = multiLegBetType === 'P' ? prices.placePrice : prices.winPrice
  return <span>{item.multiLegBetType}</span>
}
